import { NgModule, Injectable } from '@angular/core';
import { Http, RequestOptions, Headers } from '@angular/http';
import { ActivatedRoute, Router } from '@angular/router';

import {BaseService} from "../services/base-service";
import { environment } from '../../environments/environment';
import { NotificationsService } from '../shared/notifications.service';

@Injectable()
export class ConfirmOrderService extends BaseService {
  rootUrl: string =   environment.config.BASE_URL;
  baseUrl: string =   environment.config.API_URL;
  constructor(
    private _router: Router,
    public http: Http,
    public notificationsService: NotificationsService) {
      super(http, notificationsService, '');
    }
    order(obj){
        return this.http.post(this.baseUrl + 'confirmorder/', obj)
                        .toPromise().then(response => response.json());
    }

  }



// WEBPACK FOOTER //
// C:/Users/Home/OneDrive/Documents/hotellife_web/src/app/confirm-order/confirm-order.service.ts